import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=3c6cb7e0&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=3c6cb7e0&prod&lang=css"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=3c6cb7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6cb7e0",
  null
  
)

export default component.exports